import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { IconDocument } from '@redteclab/icons'

import { Button, Notification } from 'base-ui'

import { productAccessorIsPrescriptionProduct } from '../../model/productAccessor/productAccessorIsPrescriptionProduct'
import { useProductPageContext } from '../productPageContext'
import {
  ProductPrescriptionDrawer,
  useProductPrescriptionDrawerControls,
} from '../ProductPrescriptionDrawer'

export const ProductPrescriptionNotificationRequired: FC = () => {
  const { currentVariant } = useProductPageContext()
  const isPrescriptionProduct =
    productAccessorIsPrescriptionProduct(currentVariant)
  const drawerControls = useProductPrescriptionDrawerControls()

  if (!isPrescriptionProduct) {
    return null
  }

  return (
    <div className="flex flex-col gap-2.5">
      <Notification icon={<IconDocument />} severity="warning">
        <FormattedMessage id="productAdditonalInfos.prescription.infobox.content" />
      </Notification>
      <Button
        className="font-normal"
        color="secondary"
        onClick={drawerControls.handleOpen}
      >
        <FormattedMessage id="productAdditonalInfos.prescription.infobox.links" />
      </Button>
      <ProductPrescriptionDrawer controls={drawerControls} />
    </div>
  )
}
